'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Simple wrapper around the HTML5 FileReader object to turn its API into a promise based interface.
 * This doesn't expose all the functionality of the API (such as progress notifications etc, so should only be
 * used in simple situations.
 */
var readFile = function readFile(method) {
    return function (file, bytes) {
        return new Promise(function (resolve, reject) {
            var reader = new FileReader();

            reader.onload = function (onloadEvent) {
                return resolve(onloadEvent.target.result);
            };
            reader.onabort = function (onabortEvent) {
                return reject(onabortEvent);
            };
            reader.onerror = function (onerrorEvent) {
                return reject(onerrorEvent);
            };

            // TODO FLickr used webkit & mozilla fallbacks here, double check if this is necessary
            var filePortion = bytes ? file.slice(0, bytes) : file;
            reader[method](filePortion);
        });
    };
};

// Methods to place into the file reader
var readAsDataURL = exports.readAsDataURL = readFile('readAsDataURL');
var readAsArrayBuffer = exports.readAsArrayBuffer = readFile('readAsArrayBuffer');
// Not supported in IE
var readAsBinaryString = exports.readAsBinaryString = readFile('readAsBinaryString');


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/services/file/promisedFileReader.js
// module id = 468
// module chunks = 0